import { ConfigProvider } from 'antd';
import useInitLocale from 'hooks/base/locale/useInitLocale';
import useLocale from 'hooks/base/locale/useLocale';
import useInitTheme from 'hooks/base/theme/useInitTheme';
import useTheme from 'hooks/base/theme/useTheme';
// import ChangeTheme from 'pages/components/base/ChangeTheme';
import LazyLoading from 'pages/components/base/LazyLoading';
import Loading from 'pages/components/base/Loading';
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Switch } from 'react-router-dom';
import routes, { IRoute } from 'routes';
import './App.less';

interface PropsRenderRoutes {
  routes: IRoute[];
  loading?: React.ReactNode;
  baseUrl?: string;
}
export const RenderRoutes = (props: PropsRenderRoutes) => {
  const { routes, loading, baseUrl } = props;
  const { theme } = useTheme();
  return (
    <Suspense
      fallback={
        loading || (
          <LazyLoading color={theme.variables && theme.variables['@primary-color']}>
            <Loading size="3em" color={theme.variables && theme.variables['@primary-color']} />
          </LazyLoading>
        )
      }>
      <Switch>
        {routes &&
          routes.length &&
          routes.map((route: IRoute, index: number) => {
            return (
              <route.route
                key={`${baseUrl || ''}${index}`}
                path={`${baseUrl || ''}${route.path}`}
                exact={route?.exact}
                component={route.component}
              />
            );
          })}
      </Switch>
    </Suspense>
  );
};

function App() {
  useInitTheme('default');
  useInitLocale();
  const { t } = useTranslation();
  const { locale } = useLocale();
  return (
    <ConfigProvider
      locale={locale}
      form={{
        validateMessages: t('form:validate_messages', { returnObjects: true })
      }}>
      <div className="h-100vh">
        <BrowserRouter>
          <RenderRoutes routes={routes} />
          {/* <ChangeTheme /> */}
        </BrowserRouter>
      </div>
    </ConfigProvider>
  );
}

export default App;
